

import AboutContent from '../components/AboutContent';
import HeroSection from '../components/HeroSection';


import ProjectsSection from '../components/ProjectsSection';
import QASection from '../components/QASection';
import ServicesComponent from '../components/ServicesComponent';
import SubscribeForm from '../components/SubscribeForm';
import Testimonials from '../components/Testimonials';
import ToolsSection from '../components/ToolsSection'
import VerticalSection from '../components/VerticalSection';
import VideoBackground from '../components/VideoBackground';
import Marquee from '../components/Marquee';

function Homme() {
  

  return (
    <>
      <VideoBackground/>
      
      <HeroSection/>
      {/*<VerticalSection/>*/}
      <AboutContent/>
      <Marquee/>
      
      <ServicesComponent/>
      
      <ToolsSection/>
      <ProjectsSection/>
      <Testimonials/>
      <QASection/>
      <SubscribeForm/>
      
    </>  
  );
}

export default Homme;